import { writable } from 'svelte/store'

import type { ChainSocials } from '$lib/constants/chainsSocials'

export const getListedDialogStore = writable<{
	open: boolean
	chainName?: string
	chainSocials?: ChainSocials
}>({
	open: false,
})

export const metricDialogStore = writable<{
	open: boolean
	type:
		| 'tps'
		| 'max-tps'
		| 'theor-tps'
		| 'blocktime'
		| 'ttf'
		| 'governance'
		| 'launch-date'
		| 'txns'
}>({ open: false, type: 'tps' })
